export const mockRules = [
    {
        id: "R001",
        scenarioId: "SCN001",
        name: "Saat 08:00'den önce veya 22:00'den sonra satış",
        description: "Yerel saatle 22:00'den sonra satış işlemleri",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "sales" },
                {
                    join: "or",
                    conditions: [
                        { field: "beginDateTime", operator: "gte", value: "22:00" },
                        { field: "beginDateTime", operator: "lte", value: "08:00" }
                    ]
                }
            ]
        }
    },
    {
        id: "R002",
        scenarioId: "SCN001",
        name: "Kampanyalı Ürün İadesi",
        description: "İade edilen ürün için orijinal satış makbuzu bulunmaması",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "return" },
                { field: "item.itemPromotion", operator: "eq", value: true },
            ]
        },
    },
    {
        id: "R003",
        scenarioId: "SCN001",
        name: "Aynı gün içinde Ürün Satış ve İadesi",
        description: "Aynı kişi gün içinde aynı ürünü hem aldı hem iade etti.",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "return" },
                { field: "item.itemPromotion", operator: "eq", value: true },
            ]
        },
    },
    {
        id: "R004",
        scenarioId: "SCN001",
        name: "Eşleşen Satış Olmadan Para İadesi",
        description: "İade edilen ürün için orijinal satış makbuzu bulunmaması",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "return" },
                { field: "is_no_matching_sales", operator: "eq", value: true },
            ]
        },
    },
    {
        id: "R005",
        scenarioId: "SCN001",
        name: "Aynı Ürünün 3+ Kez İadesi",
        description: "Aynı kasiyer aynı ürünü aynı gün 3+ kez iade etti",
        active: false,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "return" },
                { field: "total_return_count", operator: "eq", value: 3 },
            ]
        }
    },

    {
        id: "R006",
        scenarioId: "SCN002",
        name: "Sadece Plastik Poşet",
        description: "Fis sadece plastik poşet içerir",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "sales" },
                { field: "item_count", operator: "eq", value: 1 },
                { field: "itemType", operator: "eq", value: 1001 },
            ]
        },
    },
    {
        id: "R007",
        scenarioId: "SCN002",
        name: "Sadece Alkol",
        description: "Sadece alkol ürünleri içeren makbuz",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "sales" },
                { field: "item_count", operator: "eq", value: 1 },
                { field: "itemType", operator: "eq", value: 1002 },
            ]
        },
    },

    {
        id: "R008",
        scenarioId: "SCN003",
        name: "10 Dakika İçinde Birden Fazla Iptal",
        description: "Aynı kasiyerin 10 dakika içinde 3'den fazla işlemi iptal etmesi",
        active: false,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "void" },
                { field: "total_void_count", operator: "eq", value: 3 },
                { field: "duration", operator: "eq", value: 600 },
            ]
        },
    },
    {
        id: "R009",
        scenarioId: "SCN003",
        name: "Gün Sonuna yakin İptal Edilen İşlem",
        description: "İptal edilen işlem günün son 15 dakikası içinde gerçekleşmiştir",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "void" },
                {
                    join: "or",
                    conditions: [
                        { field: "beginDateTime", operator: "gte", value: "21:45" },
                        { field: "beginDateTime", operator: "lte", value: "07:45" }
                    ]
                }
            ]
        }
    },

    {
        id: "R010",
        scenarioId: "SCN004",
        name: "Degerli Ürünlerde indirim",
        description: "'Premium' olarak işaretlenen ürüne manuel indirim uygulandı",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "modification" },
                { field: "itemType", operator: "eq", value: 1002 },
            ]
        },
    },
    {
        id: "R011",
        scenarioId: "SCN004",
        name: "Büyük İndirim Alarmı",
        description: "Toplam fiş tutarının %50’den fazla indirim alması",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "reduction" },
                { field: "reduction_percentage", operator: "eq", value: 50 },
            ]
        }
    },

    {
        id: "R012",
        scenarioId: "SCN005",
        name: "Çalışan İndirimi Limit Aşımı",
        description: "Çalışan günlük izin verilen limitten daha fazla indirim kullandı",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "reduction" },
                { field: "employee_reduction_amount", operator: "gte", value: 2 },
            ]
        }

    },
    {
        id: "R013",
        scenarioId: "SCN005",
        name: "Tek Makbuzda Birden Fazla İndirim",
        description: "Makbuzda 3'ten fazla farklı indirim türünün olmasi",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "reduction" },
                { field: "custom_reduction_count", operator: "gte", value: 3 },
            ]
        }
    },

    {
        id: "R014",
        scenarioId: "SCN006",
        name: "Ödeme bölünmesi (Nakit + Kart)",
        description: "Birden fazla makbuzda tespit edilen bölünmüş ödemeler",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "reduction" },
                {
                    join: "and",
                    conditions: [
                        { field: "tenderType", operator: "ne", value: "cash" },
                        { field: "tenderType", operator: "ne", value: "credit_card" }
                    ]
                }
            ]
        },
    },
    {
        id: "R015",
        scenarioId: "SCN006",
        name: "Aynı Kredi Kartınin 3+ Kasiyerde Kullanılmasi",
        description: "Aynı gün içinde 3+ kasiyerden yapılan işlemlerde aynı kartın kullanılması",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "reduction" },
                { field: "custom_credit_card_usage", operator: "gte", value: 3 },
            ]
        }
    },
    {
        id: "R016",
        scenarioId: "SCN005",
        name: "Mağaza Müdürü İndirimi Limit Aşımı",
        description: "Mağaza Müdürü günlük izin verilen limitten daha fazla indirim kullandı",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "reduction" },
                { field: "manager_reduction_amount", operator: "gte", value: 3 },
            ]
        }

    },
    {
        id: "R017",
        scenarioId: "SCN007",
        name: "Aynı Sadakat Kartınin gün icinde 3+ ten fazla Kullanılmasi",
        description: "Aynı gün içinde 3+ ten fazla yapılan işlemlerde aynı sadakat kartın kullanılması",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "sales" },
                { field: "custom_loyalty_card_usage", operator: "gte", value: 3 },
            ]
        }
    },
    {
        id: "R018",
        scenarioId: "SCN007",
        name: "Kendine Satış Alarmı",
        description: "Satış yapan kasiyer ile müşteri aynı kart ID’ye sahip.",
        active: true,
        createdOn: new Date().toLocaleString("tr-TR"),
        alertCount: Math.floor(Math.random() * 100),
        conditionGroup: {
            join: "and",
            conditions: [
                { field: "type", operator: "eq", value: "sales" },
                { field: "transaction.cashierId", operator: "eq", value: "transaction.loyaltyCardId" },
            ]
        }
    },
];
